export const CHOCOLATE_GIG_CARD_TYPE = 'chocolate_card';
export const BRICK_GIG_CARD_TYPE = 'brick_card';
export const SAFE_PATH_REGEX = /^[a-zA-Z0-9_-]+$/;
